import React, { Component } from "react"
import Flights from "./flights"
import { isMobile } from "react-device-detect"
import * as dateHelper from "../../booking/helpers/date"
import { DateTime } from "luxon"
import smoothscroll from "smoothscroll-polyfill"

export default class FlightsTable extends Component {
  constructor(props) {
    super(props)

    const flights = props.flights ?? []
    const flightsShown = isMobile ? props.numberOfFlightsMobile : props.numberOfFlights
    const shownFlights = flights.slice(0, flightsShown)

    smoothscroll.polyfill()

    this.state = {
      previousFlightsShown: 0,
      shownPreviousFlights: [],
      flightsShown: flightsShown,
      shownFlights: shownFlights,
    }
  }

  componentDidUpdate(prevProps) {
    const newState = {}
    if (this.props.flights !== prevProps.flights) {
      const shownFlights = this.props.flights.slice(0, this.state.flightsShown)
      newState["shownFlights"] = shownFlights
    }
    if (this.props.previousFlights !== prevProps.previousFlights) {
      const shownPreviousFlights = this.state.previousFlightsShown > 0 ? this.props.previousFlights.slice(-this.state.previousFlightsShown) : []
      newState["shownPreviousFlights"] = shownPreviousFlights
    }
    if (Object.keys(newState).length > 0) {
      this.setState(newState)
    }
  }

  getFormattedDate = (date, language) => {
    const dtLocale = dateHelper.luxonLocale(language)
    const dateTime = DateTime.fromFormat(date, "dd-MM-yyyy")
    return dateTime.setLocale(dtLocale).toFormat("d. MMMM")
  }

  handleMorePreviousFlightsClick = (increase) => {
    const previousFlights = this.props.previousFlights ?? []
    const newAmount = this.state.previousFlightsShown + increase
    const shownPreviousFlights = previousFlights.slice(-newAmount)
    this.setState({ previousFlightsShown: newAmount, shownPreviousFlights: shownPreviousFlights }, () => {
      var elements = document.getElementsByClassName("previous-flights-wrapper")
      if (elements.length > 0) {
        const element = elements[0]
        element.classList.remove("open")
        element.classList.add("opening")
        setTimeout(function () {
          element.classList.remove("opening")
          element.classList.add("open")
        }, 500)
      }
    })
  }

  handleHidePreviousFlightsClick = () => {
    this.setState({ previousFlightsShown: 0, shownPreviousFlights: [] })
  }

  handleMoreFlightsClick = (increase) => {
    const flights = this.props.flights ?? []
    const newAmount = this.state.flightsShown + increase
    const shownFlights = flights.slice(0, newAmount)
    this.setState({ flightsShown: newAmount, shownFlights: shownFlights }, () => {
      var elements = document.getElementsByClassName("next-flights-wrapper")
      if (elements.length > 0) {
        const element = elements[0]
        element.classList.remove("open")
        element.classList.add("opening")
        setTimeout(function () {
          element.classList.remove("opening")
          element.classList.add("open")
        }, 500)
      }
    })
  }

  handleHideFlightsClick = () => {
    const flights = this.props.flights ?? []
    const flightsShown = isMobile ? this.props.numberOfFlightsMobile : this.props.numberOfFlights
    const shownFlights = flights.slice(0, flightsShown)
    this.setState({ flightsShown: flightsShown, shownFlights: shownFlights }, () => {
      if (this.props.scrollIntoView) {
        this.props.scrollIntoView()
      }
    })
  }

  render() {
    const previousFlights = this.props.previousFlights ?? []
    const { shownPreviousFlights, shownFlights } = this.state

    let previousFlightsLink = ""
    if (!isMobile && previousFlights.length > 0) {
      if (this.state.previousFlightsShown >= previousFlights.length) {
        previousFlightsLink = (
          <a className="previous-flight-link" onClick={() => this.handleHidePreviousFlightsClick()}>
            {this.props.hidePreviousFlights || "Skjul tidligere fly"}
          </a>
        )
      } else {
        previousFlightsLink = (
          <a className="previous-flight-link" onClick={() => this.handleMorePreviousFlightsClick(this.props.numberOfPreviousFlights)}>
            {this.props.showPreviousFlights || "Vis tidligere fly"}
          </a>
        )
      }
    }

    let dateHeader = ""
    const firstDate = shownPreviousFlights.length > 0 ? shownPreviousFlights[0].Date : shownFlights.length > 0 ? shownFlights[0].Date : ""
    const formattedDate = this.getFormattedDate(firstDate, this.props.language)
    dateHeader = (
      <div className={`stylish-table__row stylish-table__row--head`}>
        {previousFlightsLink}
        <div className="date">{formattedDate}</div>
      </div>
    )

    return (
      <React.Fragment>
        {!isMobile ? (
          <div id="previousFlightsTable">
            <div className={`flights__table--wrapper`}>
              <div className={`flights__table stylish-table ${shownPreviousFlights.length > 0 ? "" : "no-flights"}`}>
                <div className="w--wider">
                  {dateHeader}
                  <div className={`inner-previous-flights`}>
                    <Flights
                      flights={shownPreviousFlights}
                      allFlights={previousFlights}
                      infoButtonLabel={this.props.infoButtonLabel}
                      currentUrl={this.props.currentUrl}
                      flightLandingPageExists={this.props.flightLandingPageExists}
                      language={this.props.language}
                      direction={this.props.direction}
                      onTimeStatusLabel={this.props.onTimeStatusLabel}
                      delayedStatusLabel={this.props.delayedStatusLabel}
                      getFormattedDate={this.getFormattedDate}
                      isPreviousFlights={true}
                      previousFlightsShown={this.state.previousFlightsShown}
                      increaseAmount={this.props.numberOfPreviousFlights}
                      wrapperClass={"previous-flights-wrapper"}
                      initialAmount={0}
                      amountShown={this.state.previousFlightsShown}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="flights__table stylish-table js--stylish-table" id="flightFirstTable">
          <div className="w--wider">
            <Flights
              flights={shownFlights}
              allFlights={this.props.flights}
              infoButtonLabel={this.props.infoButtonLabel}
              currentUrl={this.props.currentUrl}
              flightLandingPageExists={this.props.flightLandingPageExists}
              language={this.props.language}
              direction={this.props.direction}
              onTimeStatusLabel={this.props.onTimeStatusLabel}
              delayedStatusLabel={this.props.delayedStatusLabel}
              getFormattedDate={this.getFormattedDate}
              isPreviousFlights={false}
              previousFlightsShown={this.state.previousFlightsShown}
              lastShownPreviousFlight={shownPreviousFlights[shownPreviousFlights.length - 1]}
              increaseAmount={isMobile ? this.props.numberOfFlightsIncrementMobile : this.props.numberOfFlightsIncrement}
              wrapperClass={"next-flights-wrapper"}
              initialAmount={isMobile ? this.props.numberOfFlightsMobile : this.props.numberOfFlights}
              amountShown={this.state.flightsShown}
            />
          </div>
          <div className={`buttoncontainer ${this.props.flights && this.props.flights.length > this.props.numberOfFlights ? "has-button" : ""}`}>
            {this.props.flights && this.props.flights.length > this.props.numberOfFlights ? (
              <a
                className="button button--expander"
                onClick={() =>
                  this.state.flightsShown >= this.props.flights.length
                    ? this.handleHideFlightsClick()
                    : this.handleMoreFlightsClick(isMobile ? this.props.numberOfFlightsIncrementMobile : this.props.numberOfFlightsIncrement)
                }
              >
                <span className="text">
                  {this.state.flightsShown >= this.props.flights.length ? this.props.showLessFlightsText : this.props.showMoreFlightsText}
                </span>
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}
